import React from 'react';
import { MutedBackground } from 'scy/Background';
import styles from './styles.mod.scss';

export default function Blurb({ blurb }) {
  const { image_url, title, body } = blurb || {};
  if (!image_url && !title && !body) return null;

  return (
    <MutedBackground tag="section" className={styles.blurbSection}>
      {image_url && (
        <div
          className={styles.blurbBackground}
          style={{
            backgroundImage: `url(${image_url})`
          }}
        />
      )}
      {(title || body) && (
        <div className={styles.blurbContent}>
          {title && <h1 className={styles.blurbTitle}>{title}</h1>}
          {body && (
            <div
              className={styles.blurbBody}
              dangerouslySetInnerHTML={{ __html: body }}
            />
          )}
        </div>
      )}
    </MutedBackground>
  );
}
